import { type PanoramaClient, panoramaClientFactory } from '@wix/panorama-client-web';
import { type ErrorReportsParams } from '../../types/PayApp';
import { filterDefined } from '../filterDefined';
import { globalConfig, sentryDsn, type BaseParams } from './config';

export class PanoramaService {
  public panoramaClient: PanoramaClient;
  private errorData: ErrorReportsParams = null;

  constructor(baseParams?: BaseParams) {
    this.init(baseParams);
  }

  init(baseParams: BaseParams) {
    try {
      const panoramaFactory = panoramaClientFactory({
        baseParams,
        pluginParams: {
          sentry: window.Sentry,
          sentryDsn,
        },
      }).withGlobalConfig(globalConfig);
      this.panoramaClient = panoramaFactory.client();
    } catch (error) {
      console.error('Panorama client not initialized', error);
    }
  }

  get client(): PanoramaClient | null {
    if (!this.panoramaClient) {
      console.error('Panorama client not initialized');
      return null;
    }

    return this.panoramaClient;
  }

  get errorMonitor() {
    if (!this.panoramaClient) {
      console.error('Panorama client not initialized');
      return null;
    }
    return this.panoramaClient.errorMonitor(
      this.errorData
        ? {
            data: {
              tags: filterDefined(this.errorData),
            },
          }
        : {},
    );
  }

  destroy() {
    this.panoramaClient = null;
  }
}

export const Panorama = new PanoramaService();
